import cx from 'classnames';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';

import { InstalmentViewModel } from '../../../../../resources/contract/types';
import { AllTranslationKeys } from '../../../../../shared/intl/types';
import { snakeCaseToCamelCase } from '../../../../../shared/utilities/snakeCaseToCamelCase';

import s from './ContractInstalmentTable.css';

type Props = {
    instalment: InstalmentViewModel;
    index: string;
    currency: string;
};

export const ContractInstalmentLine = ({ instalment, index, currency }: Props): JSX.Element => {
    const instalmentStatus = snakeCaseToCamelCase(instalment.status);

    return (
        <div className={s.line} data-testid="contract-instalment-line">
            <div className={s.stateWrapper} data-testid={`${index}.status`}>
                <span className={cx(s.state, s[instalmentStatus])} />
                <FormattedMessage
                    id={`contract.instalment.status.${instalment.status}` as AllTranslationKeys}
                />
            </div>
            <div data-testid={`${index}.dueDate`}>
                <FormattedDate
                    value={instalment.dueDate}
                    day="2-digit"
                    month="short"
                    year="numeric"
                />
            </div>
            <div data-testid={`${index}.payerName`}>{instalment.payerName}</div>
            <div data-testid={`${index}.price.amount`}>
                <FormattedNumber
                    value={+instalment.price.amount}
                    style="currency"
                    currency={currency}
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                />
            </div>
        </div>
    );
};
